import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';

import { ColorPrimaryTextos, ColorHoverFila, ColorFondoHeader, ColorFondoFooter, ColorFondoFilaEven } from '../Componentes/Tool/PaletaColores';

export const StyledTableCellClass = styled(TableCell)(({ theme, Align = 'left', PaddingBody = '6px 16px' }) => ({
    textAlign: Align,
    color: ColorPrimaryTextos,
    border: "solid #E9EBEE 1px",
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: ColorFondoHeader, //'#F6F8FB',
        color: ColorPrimaryTextos,
        padding: "8px 16px"
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: '1rem',
        padding: PaddingBody,
        minHeight: '47px'
    },
    [`&.${tableCellClasses.footer}`]: {
        fontSize: '1rem',
        padding: PaddingBody,
        minHeight: '47px',
        backgroundColor: ColorFondoFooter//'#d6d6d6'
    },
}));

export const StyledTableRowHeaderClass = styled(TableRow)(({ theme }) => ({
}));

export const StyledTableRowClass = styled(TableRow)(({ theme, AplicaHover = 'N' }) => ({
    '&:nth-of-type(even)': {
        backgroundColor: ColorFondoFilaEven//'#9797970a',
    },
    "&:hover": {
        backgroundColor: ((AplicaHover === 'S') ? ColorHoverFila + " !important" : "none")
    },
    minHeight: '47px'
}));